/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './bookingsBulkSctions.scss';
import BookingDetailsFeedback from '../booking-details/BookingDetailsFeedback';

const propTypes = {
    jobs: PropTypes.array.isRequired,
    notification: PropTypes.object.isRequired,
    onFeedbackPostSuccess: PropTypes.func.isRequired,
    totalNumberOfJobsInTable: PropTypes.number.isRequired,
    onSelectAllJobs: PropTypes.func.isRequired,
    onDeselectAllJobs: PropTypes.func.isRequired,
    isBulkExclusiveMode: PropTypes.bool.isRequired,
};

class BookingsBulkActions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActive: false,
            isBulkExclusiveMode: false,
        };
    }

    toggleIsActive() {
        this.setState({
            isActive: !this.state.isActive,
        });
    }

    render() {
        const {
            jobs,
            onDeselectAllJobs,
            onSelectAllJobs,
            totalNumberOfJobsInTable,
            notification,
            onFeedbackPostSuccess,
            isBulkExclusiveMode,
            isBulkMode,
        } = this.props;
        const { isActive } = this.state;
        const countOfSelected = isBulkExclusiveMode
            ? totalNumberOfJobsInTable - jobs.length
            : jobs.length;
        if (isBulkMode) {
            return (
                <div className="bookings-bulk-actions">
                    <div className="bookings-bulk-actions__details">
                        <div>{countOfSelected} booking(s) selected</div>
                        <span
                            className="action-string"
                            onClick={onSelectAllJobs}
                            title='Sellect all bookings on this page.'
                        >
                            Select all on the page
                        </span>
                        <span
                            className="action-string"
                            onClick={onDeselectAllJobs}
                            title={'Deselect all selected bookings.'}
                        >
                            Deselect all</span>
                    </div>
                    {jobs.length || isBulkExclusiveMode ? (
                    <div>
                        <div
                            className={[
                                'bookings-bulk-actions__button',
                                isActive
                                    ? 'bookings-bulk-actions__button--active'
                                    : '',
                            ].join(' ')}
                        >
                            <button onClick={this.toggleIsActive.bind(this)}>
                                Bulk feedback
                            </button>
                        </div>
                        {(() => {
                            if (isActive) {
                                return (
                                    <div className="bookings-bulk-actions__collapsible">
                                        <BookingDetailsFeedback
                                            jobs={jobs}
                                            isBulkExclusiveMode={
                                                isBulkExclusiveMode
                                            }
                                            notification={notification}
                                            onFeedbackPostSuccess={
                                                onFeedbackPostSuccess
                                            }
                                            totalNumberOfJobsInTable={
                                                totalNumberOfJobsInTable
                                            }
                                        />
                                    </div>
                                );
                            }
                        })()}
                    </div>
                    )  : null}
                </div>
            );
        }
        return null;
    }
}

BookingsBulkActions.propTypes = propTypes;

export default BookingsBulkActions;
